<template>
  <div>
    <div
      v-if="$route.query.uid == 'A303'"
      class="divleftmenu"
      style="margin-top: 30px"
    >
      <table
        width="248"
        height="25"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <!-- style="background: url(images/bg-3.png) no-repeat center" -->
            <td
              class="b14"
              valign="bottom"
            >
              <strong class="title_cq"
                ><span class="b16-new page-header">相关产品链接</span></strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100" border="0" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td height="8"></td>
          </tr>
        </tbody>
      </table>
      <table
        width="90%"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="6"
      >
        <tbody>
          <tr>
            <td width="14%">
              <img src="./images/b33.gif" width="22" height="20" />
            </td>
            <td width="86%" valign="bottom" class="m_bl">
              <strong
                ><a
                  href="http://report.drcnet.com.cn/?version=dreport&amp;uid=780201#/weekReport?uid=%E6%9C%88%E5%BA%A6%E6%8A%A5%E5%91%8A&amp;id=900201&amp;idname=%E5%AE%8F%E8%A7%82%E7%BB%8F%E6%B5%8E"
                  style="color: #003399; font-size: 14px"
                  target="_blank"
                  >宏观经济月度研究报告</a
                ></strong
              >
            </td>
          </tr>
          <tr>
            <td>
              <img src="./images/b33.gif" width="22" height="20" />
            </td>
            <td valign="bottom" class="m_bl">
              <strong
                ><a
                  href="http://report.drcnet.com.cn/?version=dreport&amp;uid=780201#/weekReport?uid=%E5%AD%A3%E5%BA%A6%E6%8A%A5%E5%91%8A&amp;id=900201&amp;idname=%E5%AE%8F%E8%A7%82%E7%BB%8F%E6%B5%8E"
                  style="color: #003399; font-size: 14px"
                  target="_blank"
                  >宏观经济季度研究报告</a
                ></strong
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 政府工作报告 -->
    
  </div>
</template>

<script>
export default {
  name: "columnConfig",
};
</script>

<style lang="less" scoped>
.b16-new {
  /* color: #2b86e2; */
  color: darkred;
  font-size: 17px;
  font-family: "微软雅黑";
  padding-left: 10px;
}
</style>